import { render, staticRenderFns } from "./userInline.vue?vue&type=template&id=7942b7b4&scoped=true"
import script from "./userInline.vue?vue&type=script&lang=js"
export * from "./userInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7942b7b4",
  null
  
)

export default component.exports